import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from "class-validator";

@ValidatorConstraint({ async: false })
class IsStartDateBeforeEndDateConstraint
  implements ValidatorConstraintInterface
{
  validate(value: any, args: ValidationArguments): boolean {
    const params: { endDateProp: string } = args.constraints[0];
    const { endDateProp } = params;
    const propertyName: string = args.property;
    const validationObject: any = args.object;

    const startDateStr: string = validationObject[propertyName];
    const endDateStr: string = validationObject[endDateProp];
    if (!startDateStr || !endDateStr) return true;

    const startDate: Date = new Date(startDateStr);
    const endDate: Date = new Date(endDateStr);
    return startDate <= endDate;
  }
}

export function IsStartDateBeforeEndDate(
  validationOptions?: ValidationOptions,
) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName,
      constraints: [validationOptions?.context],
      validator: IsStartDateBeforeEndDateConstraint,
    });
  };
}
